import React, { useEffect, useRef, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import Layout from '../components/layout/Layout';
import { AppDispatch } from '../redux/store';
import { setSession, fetchProfile } from '../redux/authSlice';
import { handleCallback, getAccessToken } from '../services/shopifyAuth';
import { PageContainer, PageTitle, Alert, Button } from '../styles/components';

const ShopifyCallbackPage: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  const ranRef = useRef(false);

  useEffect(() => {
    // Guard against React 18 StrictMode double-invoke (the code is single-use)
    if (ranRef.current) return;
    ranRef.current = true;

    (async () => {
      try {
        const returnTo = await handleCallback();
        const token = getAccessToken();
        if (token) dispatch(setSession(token));
        await dispatch(fetchProfile());
        navigate(returnTo, { replace: true });
      } catch (e: any) {
        setError(e?.message ?? 'Innlogging feilet');
      }
    })();
  }, [dispatch, navigate]);

  return (
    <Layout>
      <Helmet>
        <title>Logger inn… | Tryllepapp</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <PageContainer>
        <PageTitle>Logger inn...</PageTitle>
        {error ? (
          <>
            <Alert variant="danger">{error}</Alert>
            <Button type="button" variant="accent" onClick={() => navigate('/login', { replace: true })}>
              Prøv igjen
            </Button>
          </>
        ) : (
          <p>Vennligst vent mens vi fullfører innloggingen.</p>
        )}
      </PageContainer>
    </Layout>
  );
};

export default ShopifyCallbackPage;
